import {ReportModel} from "@fedeltapointofsale/data-client";
import {OutgoingsReportData} from "./outgoings-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class OutgoingsReportModel extends ReportModel<OutgoingsReportData> {
    constructor(injector: Injector) {
        super(injector, OutgoingsReportData);
    }
}
